export default __webpack_public_path__ + "static/media/17.001d352d.png";